package de.xtl.retroguide

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Share
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalClipboard
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import de.xtl.retroguide.join.JoinSessionState
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import retroguide.app.shared.generated.resources.Res
import retroguide.app.shared.generated.resources.cancel_action
import retroguide.app.shared.generated.resources.invitation_share_action
import retroguide.app.shared.generated.resources.invitation_share_code_option
import retroguide.app.shared.generated.resources.invitation_share_link_option
import retroguide.app.shared.generated.resources.invitation_share_title

@Composable
fun InvitationShareButton(
    state: JoinSessionState,
    modifier: Modifier = Modifier,
    iconOnly: Boolean = false,
) {
    val clipboard = LocalClipboard.current
    val scope = rememberCoroutineScope()
    var isDialogVisible by remember { mutableStateOf(false) }
    val copyToClipboard: (String) -> Unit = { value ->
        isDialogVisible = false
        scope.launch { clipboard.setClipEntry(clipEntryWithPlainText(value)) }
    }
    val share: () -> Unit = { isDialogVisible = true }

    if (isDialogVisible) {
        AlertDialog(
            onDismissRequest = { isDialogVisible = false },
            title = { Text(stringResource(Res.string.invitation_share_title)) },
            text = {
                Column {
                    TextButton(
                        onClick = { copyToClipboard(state.invitationUrl) },
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        Text(stringResource(Res.string.invitation_share_link_option))
                    }
                    TextButton(
                        onClick = { copyToClipboard(state.sessionCode) },
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        Text(stringResource(Res.string.invitation_share_code_option))
                    }
                }
            },
            confirmButton = {
                TextButton(onClick = { isDialogVisible = false }) {
                    Text(stringResource(Res.string.cancel_action))
                }
            },
        )
    }

    if (iconOnly) {
        val shareDescription = stringResource(Res.string.invitation_share_action)
        IconButton(
            onClick = share,
            enabled = state.sessionCode.isNotBlank(),
            modifier = modifier.semantics {
                contentDescription = shareDescription
            },
        ) {
            Icon(Icons.Default.Share, contentDescription = null)
        }
    } else {
        TextButton(
            onClick = share,
            enabled = state.sessionCode.isNotBlank(),
            modifier = modifier,
        ) {
            Text(stringResource(Res.string.invitation_share_action))
        }
    }
}
